import React from "react";
import {NavLink, useNavigate} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../../inc/MemberSidebar";
import iconPencil from "../../img/icons/icon-pencil.svg";
import {confirmAlert} from "react-confirm-alert";
import Select from 'react-select'
import "react-datepicker/dist/react-datepicker.css";
import MD5 from "crypto-js/md5";

export default function BusinessForm(prop) {
    let navigate = useNavigate();

    let member = prop.member;
    let [listing, setListing] = React.useState(null);
    let [showForm, setShowForm] = React.useState(false);
    let [isReadonly, setIsReadonly] = React.useState(false);
    let [editId, setEditId] = React.useState(null);
    let [data, setData] = React.useState(null);
    let [btnDisabled, setBtnDisabled] = React.useState(false);
    let [memberDetail, setMemberDetail] = React.useState(null);

    let [certificationLevel, setCertificationLevel] = React.useState(null);
    let [certificationLevelId, setCertificationLevelId] = React.useState(null);
    let [objective, setObjective] = React.useState(null);
    let [objectiveId, setObjectiveId] = React.useState(null);
    let [certificationType, setCertificationType] = React.useState(null);
    let [certificationTypeId, setCertificationTypeId] = React.useState(null);
    let [formType, setFormType] = React.useState(null);
    let [formTypeId, setFormTypeId] = React.useState(null);
    let [statusList, setStatusList] = React.useState(null);

    let [fullnameLabel, setFullnameLabel] = React.useState('ชื่อผู้ยื่นคำขอ');
    let [addressLabel, setAddressLabel] = React.useState('ที่อยู่/ที่ตั้งสำนักงาน');
    let [identityCodeLabel, setIdentityCodeLabel] = React.useState('หมายเลขบัตรประชาชน/เลขทะเบียนคณะบุคคล/นิติบุคคล');

    let [currentFileIdcard, setCurrentFileIdcard] = React.useState(null);
    let [currentFileContractGroup, setCurrentFileContractGroup] = React.useState(null);
    let [currentFileLegalCertificate, setCurrentFileLegalCertificate] = React.useState(null);
    let [currentFilePowerAttorney, setCurrentFilePowerAttorney] = React.useState(null);
    let [currentFileSelfCertification, setCurrentFileSelfCertification] = React.useState(null);
    let [currentFileTarget, setCurrentFileTarget] = React.useState(null);
    let [currentFileTarget2, setCurrentFileTarget2] = React.useState(null);
    let [currentFileTarget3, setCurrentFileTarget3] = React.useState(null);
    let [currentFileTarget4, setCurrentFileTarget4] = React.useState(null);
    let [currentFileTarget5, setCurrentFileTarget5] = React.useState(null);
    let [currentFileTarget6, setCurrentFileTarget6] = React.useState(null);
    let [currentFileTarget7, setCurrentFileTarget7] = React.useState(null);
    let [currentFileFramework, setCurrentFileFramework] = React.useState(null);
    let [currentFileStandard, setCurrentFileStandard] = React.useState(null);
    let [currentFileAdvance, setCurrentFileAdvance] = React.useState(null);
    let [currentFileOther, setCurrentFileOther] = React.useState(null);

    //สำเนาบัตรประชาชนของผู้ยื่นคำขอ
    let [base64Idcard, setBase64Idcard] = React.useState(null);
    let refFileNameIdcard = React.useRef();
    let refFileIdcard = React.useRef();
    const handleClickIdcard = React.useCallback(() => refFileIdcard.current?.click(), []);

    //สำเนาสัญญาจัดตั้งคณะบุคคล
    let [base64ContractGroup, setBase64ContractGroup] = React.useState(null);
    let refFileNameContractGroup = React.useRef();
    let refFileContractGroup = React.useRef();
    const handleClickContractGroup = React.useCallback(() => refFileContractGroup.current?.click(), []);

    //หนังสือรับรองนิติบุคคลที่มีอายุไม่เกิน 6 เดือน จากวันที่ยื่นขอรับรอง
    let [base64LegalCertificate, setBase64LegalCertificate] = React.useState(null);
    let refFileNameLegalCertificate = React.useRef();
    let refFileLegalCertificate = React.useRef();
    const handleClickLegalCertificate = React.useCallback(() => refFileLegalCertificate.current?.click(), []);

    //หนังสือมอบอำนาจให้บุคคลดำเนินการแทนนิติบุคคล
    let [base64PowerAttorney, setBase64PowerAttorney] = React.useState(null);
    let refFileNamePowerAttorney = React.useRef();
    let refFilePowerAttorney = React.useRef();
    const handleClickPowerAttorney = React.useCallback(() => refFilePowerAttorney.current?.click(), []);

    //เอกสารรับรองตนเอง
    let [base64SelfCertification, setBase64SelfCertification] = React.useState(null);
    let refFileNameSelfCertification = React.useRef();
    let refFileSelfCertification = React.useRef();
    const handleClickSelfCertification = React.useCallback(() => refFileSelfCertification.current?.click(), []);

    //เอกสารแสดงประสบการณ์ทำงานที่สำเร็จแล้วตามเป้าหมาย
    let [base64Target, setBase64Target] = React.useState(null);
    let refFileNameTarget = React.useRef();
    let refFileTarget = React.useRef();
    const handleClickTarget = React.useCallback(() => refFileTarget.current?.click(), []);

    let [base64Target2, setBase64Target2] = React.useState(null);
    let refFileNameTarget2 = React.useRef();
    let refFileTarget2 = React.useRef();
    const handleClickTarget2 = React.useCallback(() => refFileTarget2.current?.click(), []);

    let [base64Target3, setBase64Target3] = React.useState(null);
    let refFileNameTarget3 = React.useRef();
    let refFileTarget3 = React.useRef();
    const handleClickTarget3 = React.useCallback(() => refFileTarget3.current?.click(), []);

    let [base64Target4, setBase64Target4] = React.useState(null);
    let refFileNameTarget4 = React.useRef();
    let refFileTarget4 = React.useRef();
    const handleClickTarget4 = React.useCallback(() => refFileTarget4.current?.click(), []);

    let [base64Target5, setBase64Target5] = React.useState(null);
    let refFileNameTarget5 = React.useRef();
    let refFileTarget5 = React.useRef();
    const handleClickTarget5 = React.useCallback(() => refFileTarget5.current?.click(), []);

    let [base64Target6, setBase64Target6] = React.useState(null);
    let refFileNameTarget6 = React.useRef();
    let refFileTarget6 = React.useRef();
    const handleClickTarget6 = React.useCallback(() => refFileTarget6.current?.click(), []);

    let [base64Target7, setBase64Target7] = React.useState(null);
    let refFileNameTarget7 = React.useRef();
    let refFileTarget7 = React.useRef();
    const handleClickTarget7 = React.useCallback(() => refFileTarget7.current?.click(), []);

    //เอกสารรับรองตนว่าด้วยประมวลแนวทางปฏิบัติและกรอบมาตรฐานด้านการรักษาความมั่นคงปลอดภัยไซเบอร์
    let [base64Framework, setBase64Framework] = React.useState(null);
    let refFileNameFramework = React.useRef();
    let refFileFramework = React.useRef();
    const handleClickFramework = React.useCallback(() => refFileFramework.current?.click(), []);

    //เอกสารรับรองมาตรฐานกระบวนการของผู้ให้บริการ
    let [base64Standard, setBase64Standard] = React.useState(null);
    let refFileNameStandard = React.useRef();
    let refFileStandard = React.useRef();
    const handleClickStandard = React.useCallback(() => refFileStandard.current?.click(), []);

    //เอกสารรับรองมาตรฐานกระบวนการของผู้ให้บริการ (สำหรับขั้นสูง)
    let [base64Advance, setBase64Advance] = React.useState(null);
    let refFileNameAdvance = React.useRef();
    let refFileAdvance = React.useRef();
    const handleClickAdvance = React.useCallback(() => refFileAdvance.current?.click(), []);

    //อื่นๆ
    let [base64Other, setBase64Other] = React.useState(null);
    let refFileNameOther = React.useRef();
    let refFileOther = React.useRef();
    const handleClickOther = React.useCallback(() => refFileOther.current?.click(), []);

    let refRenewNumber = React.useRef();
    let refFullname = React.useRef();
    let refIdentityCode = React.useRef();
    let refAddress = React.useRef();
    let refContactName = React.useRef();
    let refContactPhone = React.useRef();
    let refContactEmail = React.useRef();
    let refCertificateList = React.useRef();

    React.useEffect(() => {
        document.title = 'แบบฟอร์มคำร้องขอการรับรองคุณภาพ - NCSA';

        (async function() {
            try {
                const resultStatus = await Utils.getFormStatus();
                setStatusList(resultStatus);

                const result = await getListing();
                setListing(result);

                const resCertificationLevel = await Utils.getCyberCertificationLevel();
                setCertificationLevel(resCertificationLevel.rows);
                const resObjective = await Utils.getCyberObjectiveType();
                setObjective(resObjective);
                const resCertType = await Utils.getCyberCertificationType();
                setCertificationType(resCertType);
                const resFormType = await Utils.getCyberFormType();
                setFormType(resFormType);
            } catch (e) {
                //
            }
        })();

    }, []);

    async function getListing() {
        const response = await fetch(Config.apiUrl +'/cyberForm/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onAddNew = async () => {
        refRenewNumber.current.value = '';
        refFullname.current.value = '';
        refIdentityCode.current.value = '';
        refAddress.current.value = '';
        refContactName.current.value = '';
        refContactPhone.current.value = '';
        refContactEmail.current.value = '';
        refCertificateList.current.value = '';

        refFileNameIdcard.current.value = '';
        refFileNameContractGroup.current.value = '';
        refFileNameLegalCertificate.current.value = '';
        refFileNamePowerAttorney.current.value = '';
        refFileNameSelfCertification.current.value = '';
        refFileNameTarget.current.value = '';
        refFileNameTarget2.current.value = '';
        refFileNameTarget3.current.value = '';
        refFileNameTarget4.current.value = '';
        refFileNameTarget5.current.value = '';
        refFileNameTarget6.current.value = '';
        refFileNameTarget7.current.value = '';
        refFileNameFramework.current.value = '';
        refFileNameStandard.current.value = '';
        refFileNameAdvance.current.value = '';
        refFileNameOther.current.value = '';

        setCurrentFileIdcard(null);
        setCurrentFileContractGroup(null);
        setCurrentFileLegalCertificate(null);
        setCurrentFilePowerAttorney(null);
        setCurrentFileSelfCertification(null);
        setCurrentFileTarget(null);
        setCurrentFileTarget2(null);
        setCurrentFileTarget3(null);
        setCurrentFileTarget4(null);
        setCurrentFileTarget5(null);
        setCurrentFileTarget6(null);
        setCurrentFileTarget7(null);
        setCurrentFileFramework(null);
        setCurrentFileStandard(null);
        setCurrentFileAdvance(null);
        setCurrentFileOther(null);
        setBase64Idcard(null);
        setBase64ContractGroup(null);
        setBase64LegalCertificate(null);
        setBase64PowerAttorney(null);
        setBase64SelfCertification(null);
        setBase64Target(null);
        setBase64Target2(null);
        setBase64Target3(null);
        setBase64Target4(null);
        setBase64Target5(null);
        setBase64Target6(null);
        setBase64Target7(null);
        setBase64Framework(null);
        setBase64Standard(null);
        setBase64Advance(null);
        setBase64Other(null);

        setObjectiveId(null);
        setFormTypeId(null);
        setCertificationTypeId(null);
        setCertificationLevelId(null);

        setShowForm(true);
        setEditId(null);

        const resultMember = await Utils.getProfile(member);
        if(resultMember) {
            setMemberDetail(resultMember);
            refContactName.current.value = resultMember.firstname + ' ' + resultMember.lastname;
            refFullname.current.value = resultMember.businessName;
            refContactEmail.current.value = resultMember.email;
            refAddress.current.value = resultMember.businessAddress;
            refContactPhone.current.value = resultMember.businessPhone;
            refIdentityCode.current.value = resultMember.businessNo;

            //region geo
            const resProvince = await Utils.getProvince();
            setProvince(resProvince);
            refZipcode.current.value = resultMember.businessZipcode ?? '';
            if(resultMember.businessProvinceId) {
                setProvinceId(resProvince.filter(e => e.id === resultMember.businessProvinceId)[0]);
                if(resultMember.businessAmphurId) {
                    const resAmphur = await Utils.getAmphur(resultMember.businessProvinceId);
                    setAmphur(resAmphur);
                    setAmphurId(resAmphur.filter(e => e.id === resultMember.businessAmphurId)[0]);
                    if(resultMember.businessDistrictId) {
                        const resDistrict = await Utils.getDistrict(resultMember.businessAmphurId);
                        setDistrict(resDistrict);
                        setDistrictId(resDistrict.filter(e => e.id === resultMember.businessDistrictId)[0]);
                    }
                }
            }
            //endregion
        }
    };

    const onCancel = () => {
        setShowForm(false);
    };

    const onEdit = async (id) => {
        const result = await getView(id);
        if(result) {
            setData(result);
            setEditId(id);
            setShowForm(true);

            refRenewNumber.current.value = result.renewNumber;
            refFullname.current.value = result.fullname;
            refIdentityCode.current.value = result.identityCode;
            refAddress.current.value = result.address;
            refContactName.current.value = result.contactName;
            refContactPhone.current.value = result.contactPhone;
            refContactEmail.current.value = result.contactEmail;
            refCertificateList.current.value = result.certificateList;

            //region geo
            const resProvince = await Utils.getProvince();
            setProvince(resProvince);
            refZipcode.current.value = result.zipcode ?? '';
            if(result.provinceId) {
                setProvinceId(resProvince.filter(e => e.id === result.provinceId)[0]);
                if(result.amphurId) {
                    const resAmphur = await Utils.getAmphur(result.provinceId);
                    setAmphur(resAmphur);
                    setAmphurId(resAmphur.filter(e => e.id === result.amphurId)[0]);
                    if(result.districtId) {
                        const resDistrict = await Utils.getDistrict(result.amphurId);
                        setDistrict(resDistrict);
                        setDistrictId(resDistrict.filter(e => e.id === result.districtId)[0]);
                    }
                }
            }
            //endregion

            setObjectiveId(objective.filter(e => e.id === result.objective)[0]);
            setFormTypeId(formType.filter(e => e.id === result.formType)[0]);
            setCertificationTypeId(certificationType.filter(e => e.id === result.certificationType)[0]);
            setCertificationLevelId(certificationLevel.filter(e => e.id === result.certificationLevel)[0]);

            if(result.fileIdcard) {
                setCurrentFileIdcard(Config.fileUpload + "cyber_form_idcard/" + result.fileIdcard);
            }

            if(result.fileContractGroup) {
                setCurrentFileContractGroup(Config.fileUpload + "cyber_form_contract/" + result.fileContractGroup);
            }

            if(result.fileLegalCertificate) {
                setCurrentFileLegalCertificate(Config.fileUpload + "cyber_form_legal/" + result.fileLegalCertificate);
            }

            if(result.filePowerAttorney) {
                setCurrentFilePowerAttorney(Config.fileUpload + "cyber_form_power/" + result.filePowerAttorney);
            }

            if(result.fileSelfCertification) {
                setCurrentFileSelfCertification(Config.fileUpload + "cyber_form_self/" + result.fileSelfCertification);
            }

            if(result.fileTarget) {
                setCurrentFileTarget(Config.fileUpload + "cyber_form_target/" + result.fileTarget);
            }
            if(result.fileTarget2) {
                setCurrentFileTarget2(Config.fileUpload + "cyber_form_target/" + result.fileTarget2);
            }
            if(result.fileTarget3) {
                setCurrentFileTarget3(Config.fileUpload + "cyber_form_target/" + result.fileTarget3);
            }
            if(result.fileTarget4) {
                setCurrentFileTarget4(Config.fileUpload + "cyber_form_target/" + result.fileTarget4);
            }
            if(result.fileTarget5) {
                setCurrentFileTarget5(Config.fileUpload + "cyber_form_target/" + result.fileTarget5);
            }
            if(result.fileTarget6) {
                setCurrentFileTarget6(Config.fileUpload + "cyber_form_target/" + result.fileTarget6);
            }
            if(result.fileTarget7) {
                setCurrentFileTarget7(Config.fileUpload + "cyber_form_target/" + result.fileTarget7);
            }

            if(result.fileFramework) {
                setCurrentFileFramework(Config.fileUpload + "cyber_form_framework/" + result.fileFramework);
            }

            if(result.fileStandard) {
                setCurrentFileStandard(Config.fileUpload + "cyber_form_standard/" + result.fileStandard);
            }

            if(result.fileAdvance) {
                setCurrentFileAdvance(Config.fileUpload + "cyber_form_advance/" + result.fileAdvance);
            }

            if(result.fileOther) {
                setCurrentFileOther(Config.fileUpload + "cyber_form_other/" + result.fileOther);
            }
        }
    };

    const onView = async (id) => {
        await onEdit(id);
        setIsReadonly(true);
    };

    const onSubmit = () => {
        let renewNumber = refRenewNumber.current.value;
        let fullname = refFullname.current.value;
        let identityCode = refIdentityCode.current.value;
        let address = refAddress.current.value;
        let zipcode = refZipcode.current.value;
        let contactName = refContactName.current.value;
        let contactPhone = refContactPhone.current.value;
        let contactEmail = refContactEmail.current.value;
        let certificateList = refCertificateList.current.value;

        let fileNameIdcard = refFileNameIdcard.current.value;
        let fileNameContractGroup = refFileNameContractGroup.current.value;
        let fileNameLegalCertificate = refFileNameLegalCertificate.current.value;
        let fileNamePowerAttorney = refFileNamePowerAttorney.current.value;
        let fileNameSelfCertification = refFileNameSelfCertification.current.value;
        let fileNameTarget = refFileNameTarget.current.value;
        let fileNameTarget2 = refFileNameTarget2.current.value;
        let fileNameTarget3 = refFileNameTarget3.current.value;
        let fileNameTarget4 = refFileNameTarget4.current.value;
        let fileNameTarget5 = refFileNameTarget5.current.value;
        let fileNameTarget6 = refFileNameTarget6.current.value;
        let fileNameTarget7 = refFileNameTarget7.current.value;
        let fileNameFramework = refFileNameFramework.current.value;
        let fileNameStandard = refFileNameStandard.current.value;
        let fileNameAdvance = refFileNameAdvance.current.value;
        let fileNameOther = refFileNameOther.current.value;

        if(!objectiveId) {
            toast.error("กรุณาระบุ วัตถุประสงค์ในการขอรับรองคุณภาพ");
        }
        else if(objectiveId && objectiveId.id === Utils.CERTIFICATION_OBJECTIVE_RENEW && !renewNumber) {
            toast.error("กรุณาระบุ วัตถุประสงค์ในการขอรับรองคุณภาพ");
            refRenewNumber.current.focus();
        }
        else if(!formTypeId) {
            toast.error("กรุณาระบุ การขอรับการรับรองคุณภาพประเภท");
        }
        else if(!fullname) {
            toast.error("กรุณาระบุ " + fullnameLabel);
            refFullname.current.focus();
        }
        else if(!identityCode) {
            toast.error("กรุณาระบุ " + identityCodeLabel);
            refIdentityCode.current.focus();
        }
        else if(formTypeId.id === Utils.CYBERFORM_TYPE_INDIVIDUAL && (!identityCode || identityCode.length !== 13 || isNaN(identityCode))) {
            toast.error("กรุณาระบุ เลขที่บัตรประชาชน 13 หลัก");
            refIdentityCode.current.focus();
        }
        else if(!address) {
            toast.error("กรุณาระบุ " + addressLabel);
            refAddress.current.focus();
        }
        else if(!provinceId) {
            toast.error('กรุณาเลือก จังหวัด');
        }
        else if(!amphurId) {
            toast.error('กรุณาเลือก เขต/อำเภอ');
        }
        else if(!districtId) {
            toast.error('กรุณาเลือก แขวง/ตำบล');
        }
        else if(!zipcode || isNaN(zipcode) || zipcode.length !== 5) {
            toast.error('กรุณาระบุ รหัสไปรษณีย์ ตัวเลข 5 หลัก');
        }
        else if(formTypeId.id === Utils.CYBERFORM_TYPE_LEGAL && !contactName) {
            toast.error("กรุณาระบุ ชื่อ - นามสกุล (ผู้ประสานงาน)");
            refContactName.current.focus();
        }
        else if(!contactPhone || isNaN(contactPhone) || (contactPhone.length !== 10 && contactPhone.length !== 9)) {
            toast.error("กรุณาระบุ เบอร์โทรศัพท์ ตัวเลข 9 หรือ 10 หลัก");
            refContactPhone.current.focus();
        }
        else if(!contactEmail || !Utils.validateEmail.test(contactEmail)) {
            toast.error("กรุณาระบุ อีเมล ให้ถูกต้อง");
            refContactEmail.current.focus();
        }
        else if(!certificationTypeId) {
            toast.error("กรุณาระบุ ประเภทบริการที่ที่ผู้ยื่นคำขอต้องการการรับรอง");
        }
        else if(!certificationLevelId) {
            toast.error("กรุณาระบุ ระดับขั้นที่ผู้ยื่นคำขอต้องการการรับรอง");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setBtnDisabled(true);

                            let fileIdcard = data?.fileIdcard;
                            if(fileNameIdcard) {
                                fileIdcard = MD5(moment().format("YMMDDHHmmss") + '111').toString() + '.' + fileNameIdcard.split('.').pop();
                            }

                            let fileContractGroup = data?.fileContractGroup;
                            if(fileNameContractGroup) {
                                fileContractGroup = MD5(moment().format("YMMDDHHmmss") + '222').toString() + '.' + fileNameContractGroup.split('.').pop();
                            }

                            let fileLegalCertificate = data?.fileLegalCertificate;
                            if(fileNameLegalCertificate) {
                                fileLegalCertificate = MD5(moment().format("YMMDDHHmmss") + '333').toString() + '.' + fileNameLegalCertificate.split('.').pop();
                            }

                            let filePowerAttorney = data?.filePowerAttorney;
                            if(fileNamePowerAttorney) {
                                filePowerAttorney = MD5(moment().format("YMMDDHHmmss") + '444').toString() + '.' + fileNamePowerAttorney.split('.').pop();
                            }

                            let fileSelfCertification = data?.fileSelfCertification;
                            if(fileNameSelfCertification) {
                                fileSelfCertification = MD5(moment().format("YMMDDHHmmss") + '555').toString() + '.' + fileNameSelfCertification.split('.').pop();
                            }

                            let fileTarget = data?.fileTarget;
                            if(fileNameTarget) {
                                fileTarget = MD5(moment().format("YMMDDHHmmss") + 'target').toString() + '.' + fileNameTarget.split('.').pop();
                            }

                            let fileTarget2 = data?.fileTarget2;
                            if(fileNameTarget2) {
                                fileTarget2 = MD5(moment().format("YMMDDHHmmss") + 'target2').toString() + '.' + fileNameTarget2.split('.').pop();
                            }

                            let fileTarget3 = data?.fileTarget3;
                            if(fileNameTarget3) {
                                fileTarget3 = MD5(moment().format("YMMDDHHmmss") + 'target3').toString() + '.' + fileNameTarget3.split('.').pop();
                            }

                            let fileTarget4 = data?.fileTarget4;
                            if(fileNameTarget4) {
                                fileTarget4 = MD5(moment().format("YMMDDHHmmss") + 'target4').toString() + '.' + fileNameTarget4.split('.').pop();
                            }

                            let fileTarget5 = data?.fileTarget5;
                            if(fileNameTarget5) {
                                fileTarget5 = MD5(moment().format("YMMDDHHmmss") + 'target5').toString() + '.' + fileNameTarget5.split('.').pop();
                            }

                            let fileTarget6 = data?.fileTarget6;
                            if(fileNameTarget6) {
                                fileTarget6 = MD5(moment().format("YMMDDHHmmss") + 'target6').toString() + '.' + fileNameTarget6.split('.').pop();
                            }

                            let fileTarget7 = data?.fileTarget7;
                            if(fileNameTarget7) {
                                fileTarget7 = MD5(moment().format("YMMDDHHmmss") + 'target7').toString() + '.' + fileNameTarget7.split('.').pop();
                            }

                            let fileFramework = data?.fileFramework;
                            if(fileNameFramework) {
                                fileFramework = MD5(moment().format("YMMDDHHmmss") + 'framework').toString() + '.' + fileNameFramework.split('.').pop();
                            }

                            let fileStandard = data?.fileStandard;
                            if(fileNameStandard) {
                                fileStandard = MD5(moment().format("YMMDDHHmmss") + 'standard').toString() + '.' + fileNameStandard.split('.').pop();
                            }

                            let fileAdvance = data?.fileAdvance;
                            if(fileNameAdvance) {
                                fileAdvance = MD5(moment().format("YMMDDHHmmss") + 'advance').toString() + '.' + fileNameAdvance.split('.').pop();
                            }

                            let fileOther = data?.fileOther;
                            if(fileNameOther) {
                                fileOther = MD5(moment().format("YMMDDHHmmss") + 'advance').toString() + '.' + fileNameOther.split('.').pop();
                            }

                            let param = {
                                id: editId,

                                memberId: member.id,
                                objective: objectiveId.id,
                                formType: formTypeId.id,
                                renewNumber: renewNumber,
                                fullname: fullname,
                                identityCode: identityCode,
                                address: address,
                                provinceId: provinceId.id,
                                amphurId: amphurId.id,
                                districtId: districtId.id,
                                zipcode: zipcode,
                                contactName: contactName,
                                contactPhone: contactPhone,
                                contactEmail: contactEmail,
                                certificationType: certificationTypeId.id,
                                certificateList: certificateList,
                                certificationLevel: certificationLevelId.id,

                                fileIdcard: fileIdcard,
                                currentFileIdcard: data?.fileIdcard,
                                base64Idcard: base64Idcard,

                                fileContractGroup: fileContractGroup,
                                currentFileContractGroup: data?.fileContractGroup,
                                base64ContractGroup: base64ContractGroup,

                                fileLegalCertificate: fileLegalCertificate,
                                currentFileLegalCertificate: data?.fileLegalCertificate,
                                base64LegalCertificate: base64LegalCertificate,

                                filePowerAttorney: filePowerAttorney,
                                currentFilePowerAttorney: data?.filePowerAttorney,
                                base64PowerAttorney: base64PowerAttorney,

                                fileSelfCertification: fileSelfCertification,
                                currentFileSelfCertification: data?.fileSelfCertification,
                                base64SelfCertification: base64SelfCertification,

                                fileTarget: fileTarget,
                                currentFileTarget: data?.fileTarget,
                                base64Target: base64Target,

                                fileTarget2: fileTarget2,
                                currentFileTarget2: data?.fileTarget2,
                                base64Target2: base64Target2,

                                fileTarget3: fileTarget3,
                                currentFileTarget3: data?.fileTarget3,
                                base64Target3: base64Target3,

                                fileTarget4: fileTarget4,
                                currentFileTarget4: data?.fileTarget4,
                                base64Target4: base64Target4,

                                fileTarget5: fileTarget5,
                                currentFileTarget5: data?.fileTarget5,
                                base64Target5: base64Target5,

                                fileTarget6: fileTarget6,
                                currentFileTarget6: data?.fileTarget6,
                                base64Target6: base64Target6,

                                fileTarget7: fileTarget7,
                                currentFileTarget7: data?.fileTarget7,
                                base64Target7: base64Target7,

                                fileFramework: fileFramework,
                                currentFileFramework: data?.fileFramework,
                                base64Framework: base64Framework,

                                fileStandard: fileStandard,
                                currentFileStandard: data?.fileStandard,
                                base64Standard: base64Standard,

                                fileAdvance: fileAdvance,
                                currentFileAdvance: data?.fileAdvance,
                                base64Advance: base64Advance,

                                fileOther: fileOther,
                                currentFileOther: data?.fileOther,
                                base64Other: base64Other,

                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };

                            const result = await createItem(param);

                            if(result) {
                                setBtnDisabled(false);
                                if(result.status === 'success') {
                                    toast.success(prop.lang === 'en' ? 'Add team successfully.':'บันทึกข้อมูล เรียบร้อย');
                                    setTimeout(async function () {
                                        onAddNew();
                                        setShowForm(false);
                                        const listing = await getListing();
                                        setListing(listing);
                                    }, 1000);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                setBtnDisabled(false);
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function createItem(param) {
        const response = await fetch(Config.apiUrl +'/cyberForm/' + (editId ? 'updateByMember':'createByMember'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => {
                toast.error(err.message);
            });
        }
    }

    async function getView(id) {
        const response = await fetch(Config.apiUrl +'/cyberForm/viewByMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onChangeObjective = (obj) => {
        setObjectiveId(obj);
        if(obj.id === Utils.CERTIFICATION_OBJECTIVE_RENEW) {
            refRenewNumber.current.value = '';
        }
    };

    const onChangeFormType = (obj) => {
        setFormTypeId(obj);

        if(obj) {
            if(obj.id === Utils.CYBERFORM_TYPE_INDIVIDUAL) {
                setFullnameLabel('ชื่อ - นามสกุล');
                setIdentityCodeLabel('หมายเลขบัตรประชาชน');
                setAddressLabel('ที่อยู่');
                refContactName.current.value = '';

                refFullname.current.value = memberDetail.firstname + ' ' + memberDetail.lastname;
                refContactName.current.value = '';
            }
            else if(obj.id === Utils.CYBERFORM_TYPE_LEGAL) {
                setFullnameLabel('ชื่อคณะบุคคล/หน่วยงานที่ยื่นคำขอ');
                setIdentityCodeLabel('เลขทะเบียนคณะบุคคล/นิติบุคคล');
                setAddressLabel('ที่อยู่/ที่ตั้งสำนักงาน');

                refFullname.current.value = memberDetail.businessName;
                refContactName.current.value = memberDetail.firstname + ' ' + memberDetail.lastname;
            }
        }
    };

    const onChangeCertificationType = (obj) => {
        setCertificationTypeId(obj);
    };

    const onChangeCertificationLevelId = (obj) => {
        setCertificationLevelId(obj);
    };

    //region geo
    let [province, setProvince] = React.useState(null);
    let [provinceId, setProvinceId] = React.useState(null);
    let [amphur, setAmphur] = React.useState(null);
    let [amphurId, setAmphurId] = React.useState(null);
    let [district, setDistrict] = React.useState(null);
    let [districtId, setDistrictId] = React.useState(null);
    let refZipcode = React.useRef();

    const onChangeProvince = async (obj) => {
        setProvinceId(obj);
        setAmphur(null);
        setAmphurId(null);
        setDistrict(null);
        setDistrictId(null);
        refZipcode.current.value = '';
        if(obj) {
            let resAmphur = await Utils.getAmphur(obj.id);
            setAmphur(resAmphur);
        }
    };
    const onChangeAmphur = async (obj) => {
        setAmphurId(obj);
        setDistrict(null);
        setDistrictId(null);
        refZipcode.current.value = '';
        if(obj) {
            let resDistrict = await Utils.getDistrict(obj.id);
            setDistrict(resDistrict);
        }
    };
    const onChangeDistrict = async (obj) => {
        setDistrictId(obj);
        refZipcode.current.value = '';
        if(obj) {
            let resZipcode = await Utils.getZipcode(obj.id);
            refZipcode.current.value = resZipcode.zipcode;
        }
    };
    //endregion

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="businessForm" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="d-flex justify-content-between gap-3">
                                <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Business Quality Form':'แบบฟอร์มคำร้องขอการรับรองคุณภาพ'}</h3>
                                {
                                    showForm ? <button className="btn btn-xs btn-gray" onClick={onCancel}>&larr; กลับไป</button> : !listing || listing.count <= 2 ? <button className="btn btn-xs btn-light-2" onClick={onAddNew}>+ ยื่นคำร้องขอรับรองคุณภาพฯ</button> : ''
                                }
                            </div>
                            <div className={(showForm ? ' d-none':'')}>
                                <div className="table-responsive mt-3">
                                    <table className="table table-info table-hover text-center">
                                        <thead>
                                        <tr>
                                            <th>ข้อมูลการยื่น</th>
                                            <th style={{width:'250px'}}>รายละเอียด</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {
                                            listing && listing.count > 0 ?
                                                listing.rows.map((row, index) => {
                                                    let statusName = '';
                                                    if(row.status === Utils.FORM_STATUS_DRAFT) {
                                                        statusName = 'ยื่นคำขอ';
                                                    }
                                                    else if(row.status === Utils.FORM_STATUS_EDIT) {
                                                        statusName = 'อัพเดต(แก้ไข)';
                                                    }
                                                    else if(row.status === Utils.FORM_STATUS_APPROVE) {
                                                        statusName = 'รายละเอียดการชำระเงิน / แจ้งชำระเงิน';
                                                    }
                                                    else if(row.status === Utils.FORM_STATUS_EVALUATION_EDIT) {
                                                        statusName = 'ส่งอัพเดต(แก้ไข)หลังการตรวจประเมิน';
                                                    }

                                                    let appointmentDate = '';
                                                    if(row.cyberFormStatus) {
                                                        let filter = row.cyberFormStatus.filter(e => e.status === Utils.FORM_STATUS_EVALUATION_PENDING && e.appointmentDate);
                                                        if(filter && filter[0] && filter[0].appointmentDate) {
                                                            appointmentDate = Utils.dateTimeText(filter[0].appointmentDate);
                                                        }
                                                    }


                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-start">
                                                                <p><strong className="text-primary">เลขที่คำขอ :</strong> {row.code}</p>
                                                                <p><strong className="text-primary">วัตถุประสงค์ :</strong> {objective ? objective.filter(e => e.id === row.objective)[0]?.title : '-'}</p>
                                                                <p><strong className="text-primary">ประเภทบุคคล :</strong> {formType ? formType.filter(e => e.id === row.formType)[0]?.title : '-'}</p>
                                                                <p><strong className="text-primary">ประเภทบริการ :</strong> {certificationType ? certificationType.filter(e => e.id === row.certificationType)[0]?.title : '-'}</p>
                                                                <p><strong className="text-primary">ระดับขั้น :</strong> {certificationLevel ? certificationLevel.filter(e => e.id === row.certificationLevel)[0]?.title : '-'}</p>

                                                                <p><strong className="text-primary">วันที่สร้าง :</strong> {Utils.dateTimeText(row.createdAt)}</p>
                                                                <p><strong className="text-primary">วันที่อัพเดต :</strong> {Utils.dateTimeText(row.updatedAt)}</p>
                                                                <p>
                                                                    <strong className="text-primary">สถานะ :</strong> <span className={"badge " + (Utils.formStatusColor(row.status))}>{statusList.filter(e => e.id === row.status)[0]?.title}</span>
                                                                </p>

                                                                {
                                                                    row.status === Utils.FORM_STATUS_EVALUATION_PENDING || row.status === Utils.FORM_STATUS_EVALUATION_EDIT || row.status === Utils.FORM_STATUS_EVALUATION_UPDATE ?
                                                                        <p><strong className="text-primary">นัดหมายการตรวจประเมิน :</strong> {appointmentDate ? appointmentDate:'รอกำหนดวันนัดหมาย'} </p> : ''
                                                                }

                                                                {
                                                                    row.status === Utils.FORM_STATUS_CERTIFIED && row.certificate ?
                                                                        <p><strong className="text-primary">วันสิ้นสุดการรับรอง :</strong> {Utils.dateTimeDMY(row.certificate.expireDate)} (คุณต้องต่ออายุใบรับรองอีก {Math.floor(Math.abs(new Date() - new Date(row.certificate.expireDate)) / (1000 * 60 * 60 * 24))} วัน)</p> : ''
                                                                }

                                                                {
                                                                    row.status === Utils.FORM_STATUS_DRAFT || row.status === Utils.FORM_STATUS_EDIT || row.status === Utils.FORM_STATUS_APPROVE || row.status === Utils.FORM_STATUS_EVALUATION_EDIT ? <p className="mt-2"><NavLink to={'/businessFormStatus/' + Utils.encodeItem({id: row.id})} className="btn btn-xs btn-primary w-100">{statusName}</NavLink></p> : ''
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    row.status === Utils.FORM_STATUS_DRAFT || row.status === Utils.FORM_STATUS_EDIT ? <button className="btn btn-xs btn-gray w-100" onClick={e => onEdit(row.id)}><img className="icons svg-js" src={iconPencil} alt="" /> แก้ไขข้อมูล</button> : <button className="btn btn-xs btn-gray w-100" onClick={e => onView(row.id)}>รายละเอียด</button>
                                                                }

                                                                <NavLink to={'/businessPerson/' + Utils.encodeItem({id: row.id, code: row.code, status: row.status})} className="btn btn-xs btn-gray w-100 mt-2">
                                                                    ข้อมูลบุคลากร ({row.person.length})
                                                                </NavLink>

                                                                <NavLink to={'/businessSoftware/' + Utils.encodeItem({id: row.id, code: row.code, status: row.status})} className="btn btn-xs btn-gray w-100 mt-2">
                                                                    ข้อมูลอุปกรณ์และซอฟท์แวร์ ({row.software.length})
                                                                </NavLink>

                                                                <NavLink to={'/businessFormStatusList/' + Utils.encodeItem({id: row.id})} className="btn btn-xs btn-gray w-100 mt-2">รายการสถานะ</NavLink>

                                                                <NavLink to={'/businessFormCertificate/' + Utils.encodeItem({id: row.id})} className="btn btn-xs btn-gray w-100 mt-2">รายละเอียดใบรับรอง</NavLink>

                                                                {
                                                                    row.status === Utils.FORM_STATUS_DRAFT ? <NavLink to={'/businessFormStatus/' + Utils.encodeItem({id: row.id, status: Utils.FORM_STATUS_CANCELLED})} className="btn btn-xs btn-light w-100 mt-2">ลบคำขอ</NavLink> : ''
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                }): <tr><td colSpan={2} className="text-center">ไม่พบข้อมูล</td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className={"row g-3 mt-2" + (showForm ? '':' d-none')}>
                                <div className={"col-12" + (editId ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>เลขที่คำขอ</h6>
                                        <div>{data?.code ?? '-'}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>วัตถุประสงค์ในการขอรับรองคุณภาพ <span className="text-danger">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={editId || isReadonly}
                                            classNamePrefix="form-select-search"
                                            options={objective}
                                            onChange={(event) => onChangeObjective(event)}
                                            value={objectiveId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className={"col-md-6" + (objectiveId && objectiveId.id === Utils.CERTIFICATION_OBJECTIVE_RENEW ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>ใบรับรองเลขที่ <span className="text-danger">*</span></h6>
                                        <input type="text" className="form-control" id="code" ref={refRenewNumber} maxLength={250} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className={(objectiveId && objectiveId.id === Utils.CERTIFICATION_OBJECTIVE_RENEW ? 'col-md-6':'col-12')}>
                                    <div className="form-group">
                                        <h6>ต้องการขอรับการรับรองคุณภาพประเภท <span className="text-danger">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={editId || isReadonly}
                                            classNamePrefix="form-select-search"
                                            options={formType}
                                            onChange={(event) => onChangeFormType(event)}
                                            value={formTypeId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{fullnameLabel} <span className="text-danger">*</span></h6>
                                        <input type="text" className="form-control" id="code" ref={refFullname} maxLength={250} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{identityCodeLabel} <span className="text-danger">*</span></h6>
                                        <input type="text" className="form-control" id="identityCode" ref={refIdentityCode} maxLength={250} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>{addressLabel} <span className="text-danger">*</span></h6>
                                        <textarea className="form-control" id="address" ref={refAddress} maxLength={250} rows={2} readOnly={isReadonly} style={{height:70}}></textarea>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>จังหวัด <span className="star">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={editId || isReadonly}
                                            classNamePrefix="form-select-search"
                                            options={province}
                                            onChange={(event) => onChangeProvince(event)}
                                            value={provinceId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>เขต/อำเภอ <span className="star">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={!amphur || editId || isReadonly}
                                            classNamePrefix="form-select-search"
                                            options={amphur}
                                            onChange={(event) => onChangeAmphur(event)}
                                            value={amphurId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>แขวง/ตำบล <span className="star">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={!district || editId || isReadonly}
                                            classNamePrefix="form-select-search"
                                            options={district}
                                            onChange={(event) => onChangeDistrict(event)}
                                            value={districtId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>รหัสไปรษณีย์ <span className="star">*</span></h6>
                                        <input type="text" className="form-control" id="zipcode" ref={refZipcode} maxLength={5} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className={"col-12" + (formTypeId && formTypeId.id === Utils.CYBERFORM_TYPE_LEGAL ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>ชื่อ - นามสกุล (ผู้ประสานงาน) <span className="text-danger">*</span></h6>
                                        <input type="text" className="form-control" id="contactName" ref={refContactName} maxLength={250} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>หมายเลขโทรศัพท์ <span className="text-danger">*</span></h6>
                                        <input type="text" className="form-control" id="contactPhone" ref={refContactPhone} maxLength={10} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>อีเมล <span className="text-danger">*</span></h6>
                                        <input type="text" className="form-control" id="contactEmail" ref={refContactEmail} maxLength={250} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>ประเภทบริการที่ผู้ยื่นคำขอต้องการการรับรอง <span className="text-danger">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={editId || isReadonly}
                                            classNamePrefix="form-select-search"
                                            options={certificationType}
                                            onChange={(event) => onChangeCertificationType(event)}
                                            value={certificationTypeId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title + ' (' + option.title_en + ')'}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>ระดับขั้นที่ผู้ยื่นคำขอต้องการการรับรอง <span className="text-danger">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={editId || isReadonly}
                                            classNamePrefix="form-select-search"
                                            options={certificationLevel}
                                            onChange={(event) => onChangeCertificationLevelId(event)}
                                            value={certificationLevelId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>รายการประกาศนียบัตร (Certificate) สำหรับยื่นขอรับรองคุณภาพฯ</h6>
                                        <textarea className="form-control" id="certificateList" ref={refCertificateList} maxLength={1000} rows={5} readOnly={isReadonly}></textarea>
                                    </div>
                                </div>

                                <div className={"col-md-6" + (editId ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>ผู้มีอำนาจลงนามรับรอง</h6>
                                        <div>{data?.authorizedName ?? '-'}</div>
                                    </div>
                                </div>
                                <div className={"col-md-6" + (editId ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>ตำแหน่ง</h6>
                                        <div>{data?.authorizedPosition ?? '-'}</div>
                                    </div>
                                </div>


                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <h6>เอกสารประกอบพิจารณา</h6>
                                        <div className="row">
                                            <div className="col-12">
                                                <label htmlFor="fileIdcard" className="form-label">สำเนาบัตรประชาชนของผู้ยื่นคำขอ</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameIdcard} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickIdcard}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Idcard ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameIdcard.current.value = '';
                                                                    setBase64Idcard('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileIdcard} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameIdcard.current.value = e.target.files[0].name;
                                                                            setBase64Idcard(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileIdcard !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileIdcard} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileContractGroup" className="form-label">สำเนาสัญญาจัดตั้งคณะบุคคล</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameContractGroup} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickContractGroup}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64ContractGroup ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameContractGroup.current.value = '';
                                                                    setBase64ContractGroup('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileContractGroup} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameContractGroup.current.value = e.target.files[0].name;
                                                                            setBase64ContractGroup(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileContractGroup !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileContractGroup} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileLegalCertificate" className="form-label">หนังสือรับรองนิติบุคคล/คณะบุคคล ที่มีอายุไม่เกิน 6 เดือน จากวันที่ยื่นขอรับรอง</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameLegalCertificate} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickLegalCertificate}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64LegalCertificate ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameLegalCertificate.current.value = '';
                                                                    setBase64LegalCertificate('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileLegalCertificate} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameLegalCertificate.current.value = e.target.files[0].name;
                                                                            setBase64LegalCertificate(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileLegalCertificate !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileLegalCertificate} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="filePowerAttorney" className="form-label">หนังสือมอบอำนาจให้บุคคลดำเนินการแทนนิติบุคคล/คณะบุคคล</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNamePowerAttorney} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickPowerAttorney}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64PowerAttorney ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNamePowerAttorney.current.value = '';
                                                                    setBase64PowerAttorney('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFilePowerAttorney} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNamePowerAttorney.current.value = e.target.files[0].name;
                                                                            setBase64PowerAttorney(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFilePowerAttorney !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFilePowerAttorney} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileSelfCertification" className="form-label">เอกสารรับรองตนเอง</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameSelfCertification} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickSelfCertification}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64SelfCertification ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameSelfCertification.current.value = '';
                                                                    setBase64SelfCertification('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileSelfCertification} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameSelfCertification.current.value = e.target.files[0].name;
                                                                            setBase64SelfCertification(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileSelfCertification !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileSelfCertification} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>

                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileTarget" className="form-label">เอกสารแสดงประสบการณ์ทำงานที่สำเร็จแล้วตามเป้าหมาย</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameTarget} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickTarget}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Target ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameTarget.current.value = '';
                                                                    setBase64Target('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileTarget} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameTarget.current.value = e.target.files[0].name;
                                                                            setBase64Target(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileTarget !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileTarget} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileTarget2" className="form-label">เอกสารแสดงประสบการณ์ทำงานที่สำเร็จแล้วตามเป้าหมาย (2)</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameTarget2} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickTarget2}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Target2 ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameTarget2.current.value = '';
                                                                    setBase64Target2('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileTarget2} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameTarget2.current.value = e.target.files[0].name;
                                                                            setBase64Target2(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileTarget2 !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileTarget2} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileTarget3" className="form-label">เอกสารแสดงประสบการณ์ทำงานที่สำเร็จแล้วตามเป้าหมาย (3)</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameTarget3} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickTarget3}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Target3 ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameTarget3.current.value = '';
                                                                    setBase64Target3('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileTarget3} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameTarget3.current.value = e.target.files[0].name;
                                                                            setBase64Target3(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileTarget3 !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileTarget3} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileTarget4" className="form-label">เอกสารแสดงประสบการณ์ทำงานที่สำเร็จแล้วตามเป้าหมาย (4)</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameTarget4} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickTarget4}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Target4 ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameTarget4.current.value = '';
                                                                    setBase64Target4('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileTarget4} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameTarget4.current.value = e.target.files[0].name;
                                                                            setBase64Target4(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileTarget4 !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileTarget4} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileTarget5" className="form-label">เอกสารแสดงประสบการณ์ทำงานที่สำเร็จแล้วตามเป้าหมาย (5)</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameTarget5} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickTarget5}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Target5 ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameTarget5.current.value = '';
                                                                    setBase64Target5('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileTarget5} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameTarget5.current.value = e.target.files[0].name;
                                                                            setBase64Target5(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileTarget5 !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileTarget5} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileTarget6" className="form-label">เอกสารแสดงประสบการณ์ทำงานที่สำเร็จแล้วตามเป้าหมาย (6)</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameTarget6} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickTarget6}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Target6 ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameTarget6.current.value = '';
                                                                    setBase64Target6('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileTarget6} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameTarget6.current.value = e.target.files[0].name;
                                                                            setBase64Target6(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileTarget6 !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileTarget6} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileTarget7" className="form-label">เอกสารแสดงประสบการณ์ทำงานที่สำเร็จแล้วตามเป้าหมาย (7)</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameTarget7} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickTarget7}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Target7 ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameTarget7.current.value = '';
                                                                    setBase64Target7('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileTarget7} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameTarget7.current.value = e.target.files[0].name;
                                                                            setBase64Target7(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileTarget7 !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileTarget7} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>

                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileFramework" className="form-label">เอกสารรับรองตนว่าด้วยประมวลแนวทางปฏิบัติและกรอบมาตรฐานด้านการรักษาความมั่นคงปลอดภัยไซเบอร์</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameFramework} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickFramework}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Framework ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameFramework.current.value = '';
                                                                    setBase64Framework('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileFramework} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameFramework.current.value = e.target.files[0].name;
                                                                            setBase64Framework(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileFramework !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileFramework} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileStandard" className="form-label">เอกสารรับรองมาตรฐานกระบวนการของผู้ให้บริการ</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameStandard} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickStandard}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Standard ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameStandard.current.value = '';
                                                                    setBase64Standard('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileStandard} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameStandard.current.value = e.target.files[0].name;
                                                                            setBase64Standard(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileStandard !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileStandard} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileAdvance" className="form-label">เอกสารรับรองมาตรฐานกระบวนการของผู้ให้บริการ (สำหรับขั้นสูง)</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameAdvance} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickAdvance}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Advance ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameAdvance.current.value = '';
                                                                    setBase64Advance('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileAdvance} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameAdvance.current.value = e.target.files[0].name;
                                                                            setBase64Advance(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileAdvance !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileAdvance} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                            <div className="col-12 mt-3">
                                                <label htmlFor="fileOther" className="form-label">อื่นๆ</label>
                                                {
                                                    !isReadonly ?
                                                        <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" ref={refFileNameOther} readOnly={true} />
                                                                <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickOther}>เลือกไฟล์</button>
                                                                <button type="button" className={"input-group-text" + (base64Other ? ' d-block':' d-none')} onClick={e => {
                                                                    refFileNameOther.current.value = '';
                                                                    setBase64Other('');
                                                                }}>ลบ</button>
                                                            </div>
                                                            <p className="small text-danger my-1">* ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize10Mb}MB</p>
                                                            <input type="file" className="form-control d-none" ref={refFileOther} onChange={(e) => {
                                                                Utils.onSelectFile(e, Utils.maxFileSize10Mb).then(
                                                                    data => {
                                                                        if(data) {
                                                                            refFileNameOther.current.value = e.target.files[0].name;
                                                                            setBase64Other(data);
                                                                        }
                                                                    }
                                                                );
                                                            }} accept={Utils.allowFileExtension} />
                                                        </> : ''
                                                }

                                                {
                                                    currentFileOther !== null ?
                                                        <div className="col-12">
                                                            <NavLink to={currentFileOther} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                        </div> : isReadonly ? <p className="mb-0">-</p> : ''
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    !isReadonly ? <div className="col-12 mt-4">
                                        <div className="buttons gap-15 py-0">
                                            <button className="btn btn-xs btn-green" type="button" onClick={onSubmit} disabled={btnDisabled}>
                                                {prop.lang === 'en' ? 'Save':'บันทึก'}
                                            </button>
                                            <button className="btn btn-xs btn-gray me-auto" type="button" onClick={onCancel}>
                                                {prop.lang === 'en' ? 'Cancel':'ยกเลิก'}
                                            </button>
                                        </div>
                                    </div> : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 